import React from "react";
import { Link } from "react-router-dom";
import {
  FaArrowRight,
  FaMapMarkerAlt,
  FaShoppingBag,
  FaStore,
} from "react-icons/fa";
import logo from "../../logo.png";
import "./Landing.css";

const startOptions = [
  {
    to: "/hub",
    icon: <FaStore />,
    eyebrow: "Local directory",
    title: "Find local businesses",
    text: "Browse listings, communities, events, and local guides across the city.",
    chips: ["Businesses", "Communities", "Events"],
    variant: "local",
  },
  {
    to: "/HubMart",
    icon: <FaShoppingBag />,
    eyebrow: "Marketplace",
    title: "Shop HubMart",
    text: "Discover products, services, and deals from sellers near you.",
    chips: ["Products", "Services", "Deals"],
    variant: "market",
  },
];

export default function Landing() {
  const year = new Date().getFullYear();

  return (
    <div className="landing-page">
      <header className="landing-topbar">
        <Link to="/" className="landing-brand" aria-label="GoOurHub home">
          <span className="landing-brand__mark">
            <img src={logo} alt="" className="landing-brand__logo" />
          </span>
          <span className="landing-brand__name">GoOurHub</span>
        </Link>

        <nav className="landing-nav" aria-label="Primary">
          <Link to="/hub" className="landing-nav__link landing-nav__link--hide-sm">
            Businesses
          </Link>
          <Link to="/HubMart" className="landing-nav__link landing-nav__link--hide-sm">
            HubMart
          </Link>
          <Link to="/NeedHelp" className="landing-nav__link landing-nav__link--ghost">
            Need help?
          </Link>
        </nav>
      </header>

      <main className="landing-main">
        <section className="landing-hero" aria-labelledby="landing-title">
          <div className="landing-hero__content">
            <span className="landing-context">
              <FaMapMarkerAlt aria-hidden="true" />
              San Antonio, TX
            </span>

            <h1 id="landing-title" className="landing-title">
              Choose where to{" "}
              <span className="landing-title__accent">start.</span>
            </h1>

            <p className="landing-subtext">
              Browse local businesses, communities, and events   or shop
              products and deals on HubMart.
            </p>

            <div className="landing-choice-grid" aria-label="Choose where to start">
              {startOptions.map((option) => (
                <Link
                  key={option.to}
                  to={option.to}
                  className={`landing-choice landing-choice--${option.variant}`}
                >
                  <div className="landing-choice__top">
                    <span className="landing-choice__icon" aria-hidden="true">
                      {option.icon}
                    </span>
                    <span className="landing-choice__eyebrow">
                      {option.eyebrow}
                    </span>
                    <span className="landing-choice__arrow" aria-hidden="true">
                      <FaArrowRight />
                    </span>
                  </div>

                  <h2 className="landing-choice__title">{option.title}</h2>
                  <p className="landing-choice__text">{option.text}</p>

                  <div className="landing-choice__chips">
                    {option.chips.map((chip) => (
                      <span key={chip}>{chip}</span>
                    ))}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <Link to="/contact">Contact us</Link>
        <span>© {year} GoOurHub.</span>
      </footer>
    </div>
  );
}
